// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"bc0596f2","135":"5c70cfac","235":"cb18819a","249":"2861962c","554":"1f87a0cc","670":"f4c9c73c"}[chunkId] + ".chunk.css";
};